<template>
  <div class="echart-wrap">
    <div id="map" class="map" :style="{width:w,height:'490px'}"></div>
    <div id="bar" class="bar">柱状</div>
    <div id="lineNumWrap" class="line-num-wrap"><strong class="line-num">{{nowOnlineCount}}</strong>在教育人数</div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import '../assets/qinghai';
export default {
  name: 'AreaMap',
  props: {
    w:String,
    h:String
  },
  data () {
    return {
      myChartMap:null,
      ChartBar:null,
      mTime:null,
      nowOnlineCount:'',
      yearRegistCount:null,
      yearStudyCount:null,
      yearFinishedCount:null,
      barOptData:{
            // 标题
            title: {
                // left:'left',
                // borderColor:'#e6a22b',
                // borderWidth:'20'
            },
            // 工具箱
            toolbox: {
                show: true,
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'cross',
                  crossStyle: {
                      color: '#999'
                  },
                  label: {
                    color: '#fff',
                    backgroundColor : '#333'
                  }
              }
            },
            // 图例
            legend: {
                data:['注册人员','在教育人数','已完成人数'],
              // bottom:0,
              // left:'center',
                textStyle:{
                  color:'#ffffff',
                  fontSize:12
                }
            },
            // x轴
            xAxis: {
              axisLine:{//坐标轴轴线相关设置
                show:false,//是否显示坐标轴轴线
              }, 
              axisTick:{//坐标轴刻度相关设置
                  show:false,//是否显示坐标轴刻度
                  alignWithLabel:true,//可以保证刻度线和标签对齐
              },
              axisLabel:{
                  color:'#ffffff',//刻度标签文字的颜色
                  interval:0,
                  formatter:function(val,index){
                    if(index === 0){
                      val = ''
                    }
                   return val
                  }
              },
              type: 'category',
              boundaryGap: false,
              axisPointer: {
                type: 'shadow'
              },
              data: [] //2017,2018, 2019, 2020, 2021
            },
            yAxis: {
              axisLine:{//坐标轴轴线相关设置
                lineStyle:{//坐标轴线线的颜色
                    color:'biue',
                }
              },
              axisLabel:{//坐标轴刻度标签的相关设置
                  color:'#ffffff',
                  interval:0,
                  margin:0,
                  textStyle: {
                    //align:'left',
                    baseline:'middle'
                  }
              },
              splitLine:{//坐标轴在 grid 区域中的分隔线。
                  show:false,//是否显示分隔线。默认数值轴显示，类目轴不显示。
                  lineStyle:{
                    //color:'pink' //分隔线颜色，可以设置成单个颜色
                    //color:['#aaa','#ddd'],//隔线会按数组中颜色的顺序依次循环设置颜色
                  }
              },
              

            },
            // 数据
            series: [
              {
                name:'注册人员',
                type: 'line',
                smooth: true, //是否平滑
                showAllSymbol: true,
                symbol: "circle",
                symbolSize: 0,
                barWidth:10,
                color:'#ec3c87',
                data: [] //900,100,200, 1050, 2000
              },
              {
                name:'在教育人数',
                type: 'bar',
                barWidth:8,
                color:'#4f70ec',
                data: [] //0,400,500, 1500, 2000
              },
              {
                name:'已完成人数',
                type: 'bar',
                barWidth:8,
                color:'#e4a22f',
                data: [] //0,200,100, 150, 200
              }
            ],
            grid: {
                top: '30%',
                left: '3%',
                right: '4%',
                bottom: '1%',
                containLabel: true
            },
      },
      mapArr: [
        // { name: '西宁市', value: 3000 },
        // { name: '海西蒙古族藏族自治州', value: 21 },
        // { name: '海北藏族自治州', value: 60000 },
        // { name: '黄南藏族自治州', value: 45000 },
        // { name: '黄南藏族自治州', value: 20000 },
        // { name: '海东地区', value: 35000 },
        // { name: '果洛藏族自治州', value: 40000 },
        // { name: '海南藏族自治州', value: 3500 },
        // { name: '玉树藏族自治州', value: 3500 }
      ],
      cityMap:{
        // 0: "西宁市",
        // 1: "海东地区",
        // 2: "海西蒙古族藏族自治州",
        // 3: "海南藏族自治州"
      },
      geoCoordMap: {
        '西宁市': [101.778228,36.617144	],
				'海西蒙古族藏族自治州': [97.369751,37.377139], 
				'海北藏族自治州': [100.900997,36.954413], 
				'黄南藏族自治州': [102.015248,35.519548],
				'海东地区': [102.104287,36.502039], 
        '果洛藏族自治州': [100.244808,34.471431], 
        '海南藏族自治州': [100.620373,36.286437], 
        '玉树藏族自治州': [97.091934,33.011674]
			},

    }
  },
  created () {
      
  },
  mounted () {
    // console.log(this.w)
    // console.log(this.h)
     //this.drawMap();
     this.getData()
    window.addEventListener('resize', () => {
      echarts.init(document.getElementById('map')).resize()
      echarts.init(document.getElementById('bar')).resize()
    });

  },
  methods: {
    drawMap () {
      const this_ = this;
      this_.myChartMap = echarts.init(document.getElementById('map'));
      window.onresize = this_.myChartMap.resize;
      var mapOpt = {
        // 进行相关配置
        backgroundColor: "transparent",
        geo: { // 这个是重点配置区
          map: '青海', // 地区名
          roam: true,//平移或缩放
          type:'map',
          //zoom:1,
          scaleLimit:{min:0,max:3},  //缩放级别
          center: [97.6,35.0],
          label: {
            normal: { //地图上原来的文字先隐藏掉
              show: false,
              fontSize:'12',
              color: 'rgba(255, 255, 255, 0.5)'
            },
            emphasis: {
              show: false,
              color: '#fff'
            }
          },
          itemStyle: {
            normal: {
              areaColor: '#0054b8',
              borderColor: 'rgba(70, 185, 226, 0.9)'
            },
            emphasis: {
              areaColor: "#009afe",
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 20,
              borderWidth: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          regions: [
            {
              name: '海南藏族自治州',
              itemStyle: {
                areaColor: '#0023a0'
              }
            }
          ],
        },
        title: { // 设置标题
          //text: '区域',
          top: '0%',
          left: '0%',
          textStyle: {
            fontSize: 20,
            fontWeight: 300,
            color: " #96ccff",
          }
        },
        tooltip: { // 设置鼠标移上去的弹框显示效果
          //padding: 0, 
          trigger:"item",
          borderWidth: 0,
          textStyle:{
            color:'#ffffff'
          },
          backgroundColor: 'rgba(255, 139, 0, 0.9)',
          formatter:function(params){
            //console.log(params)
            let data = Array.isArray(params.value) ? params.value[2] : params.value
            return params.name +":&nbsp&nbsp"+ data; 
          }
        },
        visualMap: { // 设置地图范围值显示的颜色
          // min: 0,
          // max: 5000,
          show: true,
          splitNumber: 5,
          type: 'piecewise',
          itemWidth: 30,
          hoverLink:true,
          pieces: [
            { min: 20000, label: '20000 以上' },
            { min: 10000, max: 20000 },
            { min: 5000, max: 10000 },
            { min: 3000, max: 5000 },
            { min: 0, max: 3000 }
          ],
          inRange: {
            // color: ['#052981', '#0836af', '#2258cf', '#498af1'].reverse()
            color: ['#052981', '#4cbbfc'].reverse()
          },
          textStyle: {
            color: '#aaa',
          }
        },
        series: [
          { // 地图块的相关信息
            //name: '在教育人数',
            type: 'map',
            geoIndex: 0, // 不可缺少，否则无tooltip 指示效果
            data: this.mapArr,
            markPoint: {
              symbolSize: [25, 25],
              label: {
                position: 'top',
                color: '#fff'
              },
              silent: true,
              itemStyle: {
                color: '#0c89ca'
              },
            },
            selectedMode:false,
          },
          
					{
						type: 'effectScatter',
						coordinateSystem: 'geo',
            geoIndex: 0,
						data: this.convertData(this.mapArr.sort(function(a, b) {
							return b.value - a.value;
						}).slice(0, 10)),
						symbolSize: [15, 15],
						showEffectOn: 'render',
						rippleEffect: {
							brushType: 'stroke', //波纹绘制方式 stroke, fill
              scale: 2,
						},
						hoverAnimation: true,
						label: {
							normal: {
								formatter: '{b}',
								position: 'bottom',
								show: true,
                color:'#ffffff'
							},
              
						},
						itemStyle: {
							normal: {
								color: '#ff8003',
								shadowBlur: 10,
								shadowColor: '#80927f',
							},
						},
            zlevel: 2
					},
        ],
      }
      this_.myChartMap.setOption(mapOpt);
      this_.initAutoPlay(mapOpt)
      this_.myChartMap.on("mouseover", function (params) {
         clearInterval(this_.mTime)
         //console.log(params);
         this_.initBar(params.name)
      });
      this_.myChartMap.on("mouseout", function (){
         this_.initAutoPlay(mapOpt)
         //console.log(params)
      });
     
      
    },
    initBar(name = "西宁市"){
      this.barOptData.series[0].data = this.filterArr(this.yearRegistCount,name,'line')
      this.barOptData.series[1].data = this.filterArr(this.yearStudyCount,name)
      this.barOptData.series[2].data = this.filterArr(this.yearFinishedCount,name)
      if(this.ChartBar != null && this.ChartBar != "" && this.ChartBar != undefined){
            this.ChartBar.dispose();
      }
      this.drawBar()
    },
    initAutoPlay (mapOpt){
      var index = 0;
      var this_ = this;
      this_.mTime = setInterval(function() {
        this_.myChartMap.dispatchAction({
          type:"downplay",
          seriesIndex:0,
        });
        this_.myChartMap.dispatchAction({
          type:"highlight",
          seriesIndex: 0,
          dataIndex: index,
         // name:'玉树藏族自治州',
        });
        this_.myChartMap.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: index
        });
        let cityName = this_.cityMap[index]
        this_.initBar(cityName)
        index++;
        if(index >= mapOpt.series[0].data.length) {
          index = 0;
        }
      },6000)
    },
    drawBar (){
      this.ChartBar = echarts.init(document.getElementById('bar'));
      this.ChartBar.setOption(this.barOptData)
    },
    convertData (data) {
				var res = [];
				for (var i = 0; i < data.length; i++) {
					var geoCoord = this.geoCoordMap[data[i].name];
					if (geoCoord) {
						res.push({
							name: data[i].name,
							value: geoCoord.concat(data[i].value),
              visualMap:false
						});
					}
					
				}
        //console.log(res)
				return res;
		},
    getData () {        
       const url = '/qhjxjy_cms/DataStatistical!getData.action';     
      const this_ = this;
      this_.axios.get(url).then(res => {
        // console.log(res)
        if(res.status === 200){
          const data = res.data
          sessionStorage.setItem("backData",JSON.stringify(data))
          this_.nowOnlineCount = data.totalStudyCount;
          if (data.city) {
             let city = JSON.parse(data.city)
              city.forEach((item,index) => {
                var dataObj = {};
                dataObj.name = item[0].trim();
                dataObj.value = item[1];
                this_.cityMap[index] = item[0].trim();
                this_.mapArr.push(dataObj)
              });
              //console.log(this_.cityMap)
              this_.yearRegistCount = data.yearRegistCount;
              this_.yearStudyCount = data.yearStudyCount;
              this_.yearFinishedCount = data.yearFinishedCount;
              this_.barOptData.xAxis.data = this_.filterYearArr(this_.yearRegistCount)
              this_.drawMap();
              this_.initBar()
          };
         
          
       }
      })
    },
    filterYearArr (targetArr) {
      let yearArr = [];
      let cityNameArr = JSON.parse(targetArr)[1][1]
      //console.log(cityNameArr)
      for(let i=0; i<cityNameArr.length; i++){
        yearArr.push(cityNameArr[i][0])
      }
      return yearArr;
    },
    filterArr (targetArr,str,line=undefined) {
      let dataArr = [];
      let cityNameArr = JSON.parse(targetArr)
      cityNameArr.map( (item) => {
        if(item[0] === str){
          for(let i=0,targItem = item[1]; i<targItem.length; i++){
              dataArr.push(targItem[i][1])
          }
          if(line !== 'line'){
            dataArr.unshift('0')
          }
        }
      })
      return dataArr;
    },
  },
  watch: {

  },
  destroyed (){
    clearInterval(this.mTime)
  }
  
}
</script>

<style scoped>
.echart-wrap{
  position:relative;
}
.bar{
  width: 300px;
  height: 120px;
  /* border: 1px solid red; */
  position: absolute;
  right: 0px;
  bottom: 0px;
}
.line-num-wrap{
  position: absolute;
  right: 10px;
  top: 24px;
  /* border: 1px solid red; */
  text-align: right;
  font-size: 12px;
}
.line-num{
  font-size: 21px;
  color: #26e0dc;
  padding-right: 10px;
}
</style>
